import { Component ,Input} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';

@Component({
  selector: 'app-adminauditlog-revisions',
  templateUrl: './adminauditlog-revisions.component.html',
  styleUrls: ['./adminauditlog-revisions.component.scss']
})
export class AdminauditlogRevisionsComponent {
  @Input() public Content: any;
  subGetAuditLogRevisionList: SubscriptionLike;
  rowData: any = [];
  columnDefs: any;
  selectedRow: any;
  gridApi: GridApi;
  gridColumnApi: any
  gridOptions: any;
  rowSelection;
  public content: any;
  searchdata: any;
  RevisionNo: any = []

  action: Subject<any> = new Subject();

  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public appService: ApidataRequestService) { }

  ngOnDestroy(): void {
    if (this.subGetAuditLogRevisionList)
      this.subGetAuditLogRevisionList.unsubscribe();
  }

  ngOnInit(): void {
    this.searchdata = this.Content.content.search_data;
    var ArrayRevisionNum = this.Content.content.RevisionNo
    this.RevisionNo = ArrayRevisionNum.filter((c, index) => {
      return ArrayRevisionNum.indexOf(c) === index;
    });
    this.gridHeaderandActionSettings();
    this.rowData = [];
    this.subGetAuditLogRevisionList = this.appService.getDataPost("api/AdminAuditTrail/GetAuditTrailSearchSummary", this.searchdata).subscribe(result => {
      if (result.Status && result.Data.length > 0) {
        this.rowData = result.Data;
      } else {
        this.rowData = [];
      }
    });
  }

  gridHeaderandActionSettings() {
    this.gridOptions = {
      pagination: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      onFirstDataRendered: (params) => {
        params.api.forEachNode((node) =>
          this.RevisionNo.forEach((r) => {
            if (node.data.revision_num == r) {
              node.setSelected(true)
            }
          }
          ));
      }
    }
    this.columnDefs = [
      { headerName: "", field: 'change_description', width: 5, sortable: false, tooltipField: "ChangeDescription", headerCheckboxSelection: true, checkboxSelection: true },
      { headerName: "Revision", headerTooltip: "Revision", field: 'revision_num', width: 30, sortable: false, tooltipField: "revision_num" },
      { headerName: "Changed Date and Time", headerTooltip: "Changed Date and Time", field: 'last_modified_date_string', width: 80, sortable: false, tooltipField: "last_modified_date_string" },
      { headerName: "Username", headerTooltip: "Username", field: 'last_modfied_by', width: 100, sortable: false, tooltipField: "last_modfied_by" },
    ];
    this.rowSelection = 'multiple';
  }


  onSetGridApi(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    setTimeout(() => {
      if (true) {
        params.api.forEachNode((node: any) => {
          if (this.RevisionNo) {
            this.RevisionNo.forEach(element => {
              if (node.data.revision_num === element) {
                node.setSelected(true);
              }
            });
          }
          else {

          }
        });
      }
    }, 500);
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  OnClickOk() {
     
    this.selectedRow = this.gridApi.getSelectedRows();
   // this.action.next(this.selectedRow);
    this.modalRef.close(this.selectedRow);
  }

  cancelmodal() {
    this.modalRef.dismiss();
  }

}

